import {Box, IconButton, InputLabel, Tooltip, Typography} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import {useTheme} from '@mui/material/styles';
import {memo} from 'react';
import {RestartAlt} from "@mui/icons-material";

const MhdDatetime= ({ label, value, override, warning, error, onChange, disabled }) => {
  const theme = useTheme()
  const validateChange = (value) => {
    const parsedValue = (value && dayjs(value).isValid()) ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : '';
    onChange(parsedValue)
  };

  return (
    <>
      <InputLabel variant={error ? 'error' : 'primary'}>
        {label}
      </InputLabel>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Tooltip
          title={warning} arrow
          componentsProps={{
            tooltip: {sx: {backgroundColor: theme.palette.error.main, color: 'white'}},
            arrow: {sx: {color: theme.palette.error.main}},
          }}
        >
          <Box sx={{ position: 'relative', display: 'inline-block', width: '100%' }}>
            <DateTimePicker
              value={value ? dayjs(value) : null}
              onChange={(e) => validateChange(e)}
              disabled={disabled}
              viewRenderers={{
                hours: null,
                minutes: null,
                seconds: null,
              }}
              format='YYYY-MM-DD HH:mm:ss'
              error={!!error}
              ampm={false}
            />
            <IconButton
              onClick={() => onChange('')}
              color={'primary'}
              sx={{
                position: 'absolute',
                zIndex: 1,
                right: -8,
                top: -8,
                width: 8,
                height: 8,
              }}
            >
              <RestartAlt fontSize='small' />
            </IconButton>
          </Box>
        </Tooltip>
      </LocalizationProvider>

      {(override) &&
        <Typography variant='caption' color='error'>
          Modified: {dayjs(override).format('YYYY-MM-DD HH:mm:ss')}
        </Typography>
      }
    </>
  );
}

export default memo(MhdDatetime);